import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import styled from "styled-components";
import { useUiStore } from "@/stores/UiStore";
import AppSkeleton from "./AppSkeleton";
import { useUpdatePlan } from "@/hooks/useUpdatePlan";
import useWideLayout from "@/hooks/useWideLayout";
import { ShowOnceWebinarDialog } from "@/features/changelog/ShowOnceWebinarDialog";

const StyledAppLayout = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.$expanded ? "18rem" : "5rem")} 1fr;
  grid-template-rows: ${(props) => props.$showHeader && "auto"} 1fr;
  min-height: 100vh;
  transition: all 0.3s;
`;

const Main = styled.main`
  background-color: var(--gray-100);
  padding: 4rem ${(props) => (props.$wideLayout ? "0.8rem" : "4.8rem")} 0.5rem;
`;

export const Container = styled.div`
  max-width: ${(props) => (props.$wideLayout ? "auto" : "75rem")};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
  height: 100%;
`;

export function AppLayoutMain() {
  const wideLayout = useUiStore((state) => state.wideLayout);

  useWideLayout(false);
  // used to update session
  useUpdatePlan();
  return (
    <Main $wideLayout={wideLayout} id="main">
      <Container $wideLayout={wideLayout} id="main-container">
        <Outlet />
      </Container>
    </Main>
  );
}

export function AppLayoutSidebar() {
  const sidebarExpanded = useUiStore((state) => state.sidebarExpanded);

  // used to update session
  useUpdatePlan();

  return (
    <StyledAppLayout $expanded={sidebarExpanded} $showHeader={false}>
      {/* {showUpgrade && <Header />} */}
      <Sidebar isLoading={false} />
      <Outlet />
    </StyledAppLayout>
  );
}

export function LoadingAppLayout() {
  return (
    <StyledAppLayout $expanded={false} $showHeader={false}>
      <Sidebar isLoading={true} />
      <Main>
        <Container>
          <AppSkeleton />
        </Container>
      </Main>
    </StyledAppLayout>
  );
}
